// lib/whatsapp/intake-dates.ts
/**
 * Fechas rápidas del asistente WhatsApp (WhatsAppIntakeSheet) — módulo puro
 * sin imports de UI para que los tests tsx puedan importarlo sin arrastrar
 * CSS de componentes (react-day-picker/style.css no compila bajo tsx).
 *
 * Día y serialización SIEMPRE en hora local (addDaysLocalISO): mezclar
 * getDay() local con toISOString() UTC corría el rango un día tras las 19:00
 * en Bogotá (auditoría 2026-06-10).
 */

import { addDaysLocalISO } from '@/lib/dateUtils';

/** Rangos rápidos de la variante stay — el caso común a 1 tap (research 2026:
 *  reducir taps en el paso de fechas es la palanca #1 de completion en mobile
 *  booking). */
export function quickRanges(now = new Date()): Array<{ label: string; arrival: string; nights: number }> {
  const dow = now.getDay(); // 0=domingo
  const daysToFri = (5 - dow + 7) % 7; // 0 si hoy es viernes
  return [
    { label: 'Este fin de semana', arrival: addDaysLocalISO(now, daysToFri), nights: 2 },
    { label: 'Próximo fin de semana', arrival: addDaysLocalISO(now, daysToFri + 7), nights: 2 },
  ];
}

/** Fechas rápidas de la variante tour (fecha única). Dedup por ISO: si hoy es
 *  viernes, "Mañana" y "Este sábado" serían el mismo día — se conserva el
 *  primero. */
export function tourQuickDates(
  now = new Date(),
  minDateISO?: string,
  /** Hoy en Bogotá, solo cuando el tour admite salida urgente (hora conocida y
   *  antes de la salida). Sin él no se ofrece «Hoy». */
  urgentTodayISO?: string
): Array<{ label: string; date: string }> {
  const dow = now.getDay(); // 0=domingo
  const daysToSat = (6 - dow + 7) % 7;
  const daysToSun = (7 - dow) % 7;
  const candidates = [
    ...(urgentTodayISO ? [{ label: 'Hoy', date: urgentTodayISO }] : []),
    { label: 'Mañana', date: addDaysLocalISO(now, 1) },
    { label: 'Este sábado', date: addDaysLocalISO(now, daysToSat === 0 ? 7 : daysToSat) },
    { label: 'Este domingo', date: addDaysLocalISO(now, daysToSun === 0 ? 7 : daysToSun) },
  ];
  const out: Array<{ label: string; date: string }> = [];
  for (const c of candidates) {
    if ((!minDateISO || c.date >= minDateISO) && !out.some((o) => o.date === c.date)) {
      out.push(c);
    }
  }
  return out;
}
